import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import ClientViewer from './ClientViewer';
import ProjectDetails from './ProjectDetails';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/client-viewer" element={<ClientViewer />} />
        <Route path="/project/:projectNumber" element={<ProjectDetails />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
